import i18n from 'i18n-js';

import ptBR from './ptBR.json';
import es from './es.json';

i18n.defaultLocale = 'ptBR';
i18n.locale = 'ptBR';
i18n.fallbacks = true;
i18n.translations = { ptBR, es };

export default i18n;